import { render, staticRenderFns } from "./ClientPageHeading.vue?vue&type=template&id=39979bfd&"
import script from "./ClientPageHeading.vue?vue&type=script&lang=js&"
export * from "./ClientPageHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports